import { render, staticRenderFns } from "./MAP.vue?vue&type=template&id=19701b21&scoped=true"
import script from "./MAP.vue?vue&type=script&lang=ts"
export * from "./MAP.vue?vue&type=script&lang=ts"
import style0 from "./MAP.vue?vue&type=style&index=0&id=19701b21&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19701b21",
  null
  
)

export default component.exports